import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '../../../Typography/Typography';
export const Label = ({ label }) => {
    if (!label)
        return null;
    return (_jsx(Typography.Text, { weight: 'medium', size: 'sm', children: label }));
};
